export default "__VITE_ASSET__CBE8pJCP__"